import React from 'react'


import RebateResult from './RebateResult';
import RebateResultNotFound from './RebateResultNotFound';
import { customColors } from './RebateWidget';
import { RebateDataNoUnderscores } from '../../../incentive-hub/types';
import { PublishedIncentiveData } from '../../../rebatefinder/rebate-result-IMP.tsx/rebate-result-component';
import { Incentive } from '../../../rebatefinder/rebate-result-IMP.tsx/rebate-types';
import { RebateResultCard } from '../../../rebatefinder/rebate-result-IMP.tsx/rebate-result-card';
import { convertDate, generateDescriptionWithData } from '../../../rebatefinder/rebate-result-IMP.tsx/Functions_lib.tsx/description_generation';
import { Box } from '@mui/material';

//need to understand how to make a type globally available so not creating it in each component



interface RebateResultsListProps{
    data : Incentive[];
    zipCode : string;
    colors : customColors

}


const RebateResultList : React.FC<RebateResultsListProps> = ({colors, data , zipCode}) => {
    if (data.length > 0){
        let displayArray = []
        for(let result of data){
            displayArray.push(

            <Box sx={{paddingTop: 1, paddingBottom: 1}}>
                <RebateResultCard 
                    product={result.incentiveproductsubcategory?.incentiveproductgeneral?.incentiveproductgeneralname ?? ""}
                    incentiveAmount = {result.incentiveamount ?? ""}
                    incentiveType={result.incentivetype?.incentivetypename ?? ""}
                    partnerName={result.workspace?.incentiveorganization?.incentiveorganizationname ?? ""}
                    startDate={convertDate(parseInt(result.incentivestartedate ?? ""))}
                    endDate={convertDate(parseInt(result.incentiveenddate ?? ""))}
                    description={generateDescriptionWithData(result, result.incentiveproductsubcategory?.incentiveproductgeneral?.incentiveproductgeneralname ?? "", convertDate(parseInt(result.incentivestartedate ?? "")),convertDate(parseInt(result.incentiveenddate ?? "")), "")}
                    productDetail={result.incentiveproductsubcategory?.incentiveproductsubcategoryname ?? ""}
                    customerHotline=''
                    programWebAddress={result.programwebaddress ?? ""}
                    isIncomeQualified={false}
                />
            </Box>
        )
        }
        return displayArray
        
    } 
    else{
    return (

        <>
            <RebateResultNotFound colors={colors} zip={zipCode} />
        </>
    )
    }
}

export default RebateResultList